export default __webpack_public_path__ + "static/media/produits_sains-1.adfbf996.png";